module.exports = __webpack_public_path__ + "static/media/brand-refresh-radio-on.f898084e.svg";